import { Grid, makeStyles, Typography } from "@material-ui/core";

import { LogoText } from "../../components/logoText";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    borderTop: "2px solid",
    position: "fixed",
    bottom: 0,
    backgroundColor: "#E9E9E9",
    zIndex: 10000,
  },
  demoRoot: {
    padding: theme.spacing(3),
  },
}));

export const Bottom = ({ demoLayout }) => {
  const classes = useStyles();

  return (
    <Grid
      className={demoLayout ? classes.demoRoot : classes.root}
      container
      justifyContent="flex-end"
    >
      <Typography>Powered by&nbsp;</Typography>
      <LogoText variant="body1" />
    </Grid>
  );
};
